import React, { useState, useEffect } from "react"
import styled from "styled-components"

import MetaData from "@/common/components/MetaData"
import ResetCSS from "@/common/assets/css/style"
import ResultCard from "@/containers/MoneyFortune/View/result/ResultCard"
import {
  ResultDate,
  GetAndShare
} from "@/containers/MoneyFortune/money-fortune-data/ResultData"

export default function Result() {
  const [resultPageData, setResultPageDate] = useState({})
  useEffect(() => {
    const resultfilter = ResultDate.filter(value => {
      return value.roleID === "Musk"
    })[0]

    setResultPageDate(resultfilter)
  }, [])

  return (
    <Wrapper>
      <MetaData
        title={`我的代表人物是 現實版鋼鐵人 - 馬斯克`}
        description="身為夢想家的你，一有目標就奮不顧身的往前衝，執行力與專注的心能夠讓你真正強大。雖然不見得總是一帆風順，但堅持跟努力將資訊研究得更透測，最終還是會獲得好的回報。"
        url={`https://www.kryptogo.com/money-fortune/Musk`}
        image="https://i.ibb.co/Dpq70Yf/OG-Musk.webp"
      />
      <ResetCSS />
      <ResultCard
        key={resultPageData.roleID}
        name={resultPageData.name}
        AKA={resultPageData.AKA}
        chance={resultPageData.chance}
        saying={resultPageData.saying}
        summary={resultPageData.summary}
        analysis={resultPageData.analysis}
        investment={resultPageData.investment}
        befit={resultPageData.befit}
        img={resultPageData.img}
        type="share"
        GetAndShare={GetAndShare}
        API={GetAndShare.API}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  * {
    ::-webkit-scrollbar-thumb {
      background: #00fff0;
      border-radius: 5px;
    }
    ::-webkit-scrollbar {
      width: 2px;
      background-color: none;
    }
  }
`
